/* eslint-disable no-unused-vars */
import { Search, RotateCw, Menu, ChevronDown, ChevronUp } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../../components/atoms/Loader'
import RowEmpty from '../../../components/atoms/RowEmpty'
import {
  BadgeStatusCOA,
  BadgeStatusPrList,
  BadgeStatusPrLists
} from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import ModalAddSelectStagingArea from '../../../components/modal/Inbound/ModalAddSelectStagingArea'
import ModalSelectCreatePrMethod from '../../../components/modal/pr/ModalSelectCreatePrMethod'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const PurchaseReceipt = () => {
  const [loading, setLoading] = useState(false)
  const [prDraftList, setPrDraftList] = useState([])
  const [prDraftId, setPrDraftId] = useState('')
  const [expandedRows, setExpandedRows] = useState(null)
  const [idWarehouseDst, setIdWarehouseDst] = useState()
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const { per_page, current_page } = meta
  const [selectedPrinciple, setSelectedPrinciple] = useState('')
  const [principles, setPrinciples] = useState([])
  const refSrcPrinciples = useRef()
  const [selectedWarehouse, setSelectedWarehouse] = useState('')
  const [warehouses, setWarehouses] = useState([])
  const refSrcWarehouses = useRef()
  const refSrcPos = useRef()
  const [showModalStaging, setShowModalStaging] = useState(false)
  const [inboundData, setInboundData] = useState({})
  const [modalSelectMethodShow, setModalSelectMethodShow] = useState(false)
  const [inputPo, setInputPo] = useState('')
  const [debouncedPrDraftId, setDebouncedPrDraftId] = useState(prDraftId)
  const [debouncedInputPo, setDebouncedInputPo] = useState(inputPo)
  const [openSearch, setOpenSearch] = useState(false)

  const handleExpandRow = (userId, idWarehouse) => {
    setIdWarehouseDst(idWarehouse)
    let currentExpandedRows = null
    const isRowExpanded = currentExpandedRows === userId ? userId : null
    const newExpandedRows = isRowExpanded
      ? null
      : (currentExpandedRows = userId)
    if (expandedRows !== userId) {
      setExpandedRows(newExpandedRows)
    } else {
      setExpandedRows(null)
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedPrDraftId(prDraftId)
      setDebouncedInputPo(inputPo)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [prDraftId, inputPo])

  useEffect(() => {
    fetchPRLIST(
      per_page,
      current_page,
      debouncedPrDraftId,
      debouncedInputPo,
      selectedPrinciple,
      selectedWarehouse
    )
  }, [
    per_page,
    current_page,
    debouncedPrDraftId,
    debouncedInputPo,
    selectedPrinciple,
    selectedWarehouse
  ])

  useEffect(() => {
    getPrinciples()
    getWarehouses()
  }, [])

  const getPrinciples = async () => {
    try {
      const options = [{ value: '', label: 'All' }]
      const res = await api.get('/inbound/purchase-order/principles')
      const { data } = res.data
      data.map((data) =>
        options.push({ value: data.supplier, label: data.supplier })
      )
      setPrinciples(options)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const getWarehouses = async () => {
    try {
      const options = [{ value: '', label: 'All' }]
      const res = await api.get('/inbound/purchase-order/dest-warehouses')
      const { data } = res.data
      data.map((data) =>
        options.push({ value: data.set_warehouse, label: data.set_warehouse })
      )
      setWarehouses(options)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  async function fetchPRLIST(
    per_page,
    current_page,
    prDraftId,
    inputPo,
    selectedPrinciple,
    selectedWarehouse
  ) {
    setLoading(true)
    try {
      const res = await api.get('inbound/pr-draft', {
        params: {
          per_page,
          page: current_page,
          principle: selectedPrinciple || '',
          dest_warehouse: selectedWarehouse || '',
          po: inputPo || '',
          pr_draft: prDraftId || ''
        }
      })
      const { metadata, data } = res.data
      setPrDraftList(data)
      setMeta(metadata)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  const navigate = useNavigate()
  const navigateToDetail = (purchaseOrder) => {
    const encodedName = encodeURIComponent(purchaseOrder.id)
    if (purchaseOrder.is_packing) {
      navigate(`/inbound/purchase-receipt/detail/packing/${encodedName}`)
    } else {
      navigate(`/inbound/purchase-receipt/${encodedName}`)
    }
  }

  function handleReset(e) {
    refSrcPrinciples.current?.clearValue()
    refSrcWarehouses.current?.clearValue()
    refSrcPos.current?.clearValue()
    setPrDraftId('')
    setInputPo('')
    setDebouncedPrDraftId('')
    setDebouncedInputPo('')
    setSelectedPrinciple('')
    setSelectedWarehouse('')
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: 10,
      current_page: 1
    }))
  }

  const handleShowModalStagingArea = (data) => {
    setShowModalStaging(true)
    setInboundData(data)
  }

  function handleCreate() {
    setModalSelectMethodShow(true)
  }

  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    done: 'done',
    revised: 'waiting rnr'
  }

  const statusCoaMapping = {
    unchecked: 'unchecked',
    match: 'match',
    not_match: 'not match'
  }

  const SelectStyles = {
    control: (base, state) => ({
      ...base,
      height: 45,
      minHeight: 45,
      borderRadius: '10px',
      borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
      boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
      backgroundColor: '#ffffff',
      border: '1px solid #e9ecef',
      fontSize: '0.9rem'
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '45px',
      padding: '0 12px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#495057'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? 'var(--primary-orange)'
        : state.isFocused
          ? '#fff5e6'
          : null,
      color: state.isSelected ? 'white' : '#333',
      cursor: 'pointer'
    })
  }

  const FormControlStyle = {
    height: '45px',
    borderRadius: '10px',
    border: '1px solid #e9ecef',
    backgroundColor: '#ffffff',
    fontSize: '0.9rem'
  }

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 style={headerTitleStyle}>PR Draft List</h3>
          </Col>
          <Col className="text-end">
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border me-2"
              onClick={() => handleReset()}
              style={{ fontSize: '0.85rem' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
            <Button
              className="btn btn-primary-blue rounded px-3"
              onClick={() => handleCreate()}
            >
              <small className="fw-bold">+ Create PR Draft</small>
            </Button>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>PR DRAFT</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="pr_draft"
                    id="pr_draft"
                    placeholder="Search by PR Draft..."
                    onChange={(e) => setPrDraftId(e.target.value)}
                    value={prDraftId}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>PO</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="po"
                    id="po"
                    placeholder="Search by PO..."
                    onChange={(e) => setInputPo(e.target.value)}
                    value={inputPo}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>PRINCIPLE</Form.Label>
                <Select
                  isClearable
                  defaultValue={selectedPrinciple}
                  onChange={(e) => {
                    setSelectedPrinciple(e?.value || '')
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={principles}
                  isSearchable
                  ref={refSrcPrinciples}
                  styles={SelectStyles}
                  placeholder="All Principles"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>ACCEPTED WAREHOUSE</Form.Label>
                <Select
                  isClearable
                  defaultValue={selectedWarehouse}
                  onChange={(e) => {
                    setSelectedWarehouse(e?.value || '')
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={warehouses}
                  isSearchable
                  ref={refSrcWarehouses}
                  styles={SelectStyles}
                  placeholder="All Warehouses"
                />
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-3">
          <Col md={12}>
            <Table
              hover
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #PR DRAFT
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #PO
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Principle
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Destination Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Created
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Status COA
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Status
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '12px' }}>
                {loading && (
                  <tr>
                    <td colSpan={8}>
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading && prDraftList.length === 0 && (
                  <RowEmpty colSpan={8} />
                )}
                {!loading &&
                  prDraftList?.map((data, i) => {
                    return (
                      <>
                        <tr
                          key={i}
                          style={{ borderBottom: '1px solid #f0f0f0' }}
                        >
                          <td className="p-2 align-middle fw-semibold text-primary">
                            {data.pr_draft}
                          </td>
                          <td className="p-2 align-middle">{data.po_code}</td>
                          <td
                            className="p-2 align-middle text-muted"
                            style={{ width: '15%' }}
                          >
                            {data.principle}
                          </td>
                          <td
                            className="p-2 align-middle text-muted"
                            style={{ width: '15%' }}
                          >
                            {data.dest_warehouse_id}
                          </td>
                          <td
                            className="p-2 align-middle text-muted"
                            style={{ width: '8%' }}
                          >
                            {convertDateWithTime(data?.created_at)}
                          </td>
                          <td
                            className="p-2 align-middle text-end"
                            style={{ width: '15%' }}
                          >
                            <BadgeStatusCOA
                              text={
                                statusCoaMapping[data.coa_status] || 'unchecked'
                              }
                            />
                          </td>
                          <td className="p-2 align-middle text-end">
                            <BadgeStatusPrList text={data.draft_status} />
                          </td>
                          <td className="p-2 align-middle text-end">
                            <TableAction>
                              <button
                                className="btn btn-light text-secondary border rounded"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  padding: 0,
                                  marginRight: '8px'
                                }}
                                onClick={() => {
                                  navigateToDetail(data)
                                }}
                                title="View Detail"
                              >
                                <Search size={14} />
                              </button>
                              <button
                                className="btn btn-light text-secondary border rounded"
                                onClick={() =>
                                  handleExpandRow(
                                    i,
                                    data.dest_warehouse_id,
                                    data
                                  )
                                }
                                disabled={!data.inbounds.length}
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  padding: 0
                                }}
                                title="Expand"
                              >
                                <Menu size={14} />
                              </button>
                            </TableAction>
                          </td>
                        </tr>
                        {expandedRows === i ? (
                          <>
                            <tr className="table-secondary collaps-viewer fw-bold">
                              <td colSpan={2} className="pt-3 ps-5 pe-5 pb-2">
                                Ticket
                              </td>
                              <td className="pt-3 ps-5 pe-5 pb-2">Car</td>
                              <td colSpan={1} className="pt-3 ps-5 pe-5 pb-2" />
                              <td
                                colSpan={3}
                                className="text-end pt-3 ps-5 pe-5 pb-2"
                              >
                                Staging Area
                              </td>
                              <td className="text-end pt-3 ps-5 pe-5 pb-2">
                                Status
                              </td>
                            </tr>
                            {data.inbounds.length === 0 && (
                              <tr>
                                <td colSpan={5}>No Data...</td>
                              </tr>
                            )}
                            {data.inbounds.map((data, i) => {
                              return (
                                <tr className="bg-secondary" key={i}>
                                  <td
                                    colSpan={2}
                                    className="pt-3 ps-5 pe-5 pb-4"
                                  >
                                    {data.ticket}
                                  </td>
                                  <td className="pt-3 ps-5 pe-5 pb-4">
                                    {data.vehicle}
                                  </td>
                                  <td
                                    colSpan={1}
                                    className="pt-3 ps-5 pe-5 pb-4"
                                  />
                                  <td
                                    colSpan={3}
                                    className="pt-3 ps-5 pe-5 pb-4"
                                  >
                                    <div
                                      className="d-flex justify-content-end"
                                      onClick={() =>
                                        data.status === 'unassigned' ||
                                        data.status === 'waiting'
                                          ? handleShowModalStagingArea(data)
                                          : ''
                                      }
                                      style={{
                                        cursor:
                                          data.status === 'unassigned' ||
                                          data.status === 'waiting'
                                            ? 'pointer'
                                            : ''
                                      }}
                                    >
                                      {data.stagings.length > 0 ? (
                                        data.stagings
                                          .map((data) => data.name)
                                          .join(', ')
                                      ) : (
                                        <>
                                          Select Staging Area
                                          {openSearch ? (
                                            <ChevronUp
                                              size={14}
                                              className="ms-2 mt-1"
                                            />
                                          ) : (
                                            <ChevronDown
                                              size={14}
                                              className="ms-2 mt-1"
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td className="text-end pt-3 ps-5 pe-5 pb-4">
                                    <BadgeStatusPrLists
                                      text={
                                        statusTextMapping[data.status] || 'done'
                                      }
                                    />
                                  </td>
                                </tr>
                              )
                            })}
                          </>
                        ) : null}
                      </>
                    )
                  })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={11} className="p-3 border-top-0">
                    <TablePagination
                      meta={meta}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </Container>

      <ModalAddSelectStagingArea
        show={showModalStaging}
        onHide={() => setShowModalStaging(false)}
        id={idWarehouseDst}
        data={inboundData}
        refreshData={() => fetchPRLIST()}
      />

      <ModalSelectCreatePrMethod
        show={modalSelectMethodShow}
        onHide={() => setModalSelectMethodShow(false)}
      />
    </>
  )
}

export default PurchaseReceipt
